import { Theme } from '@mui/material/styles';
import {
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../tokens';

export const styledMuiAlert = (theme: Theme): Record<string, unknown> => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      border: `1px solid ${getSurfaceBorder(theme, 'strong')}`,
      borderRadius: radii.lg,
      boxShadow: tokens.shadowSoft,
    },
    standardInfo: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      color: theme.palette.info.dark,
    },
    standardSuccess: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      color: theme.palette.success.dark,
    },
    standardWarning: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      color: theme.palette.warning.dark,
    },
    standardError: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      color: theme.palette.error.dark,
    },
  };
};
